import { Search } from "lucide-react";

const SEL_CLS = "px-3 py-2 text-sm border border-[#E6E1D6] rounded";
const LBL_CLS = "block text-[10px] uppercase tracking-wider text-[#978D78] mb-1";

export default function SummaryFilters({
  tipo, setTipo, hasResumo, setHasResumo, q, setQ,
  setPage, onSearch,
}) {
  return (
    <div className="flex flex-wrap items-end gap-3 p-3 bg-white rounded-xl border border-[#E6E1D6]">
      <div>
        <label className={LBL_CLS}>Tipo</label>
        <select value={tipo}
          onChange={(e) => { setTipo(e.target.value); setPage(1); }}
          data-testid="ms-filter-tipo" className={SEL_CLS}>
          <option value="AU">Áudios (AU)</option>
          <option value="V2" disabled title="Fase 2 — aguarda ffmpeg">Vídeos (V2) — em breve</option>
        </select>
      </div>
      <div>
        <label className={LBL_CLS}>Resumo</label>
        <select value={hasResumo}
          onChange={(e) => { setHasResumo(e.target.value); setPage(1); }}
          data-testid="ms-filter-resumo" className={SEL_CLS}>
          <option value="false">Sem resumo</option>
          <option value="true">Com resumo</option>
          <option value="">Todos</option>
        </select>
      </div>
      <form onSubmit={onSearch} className="flex-1 min-w-[200px] flex items-end gap-2">
        <div className="flex-1">
          <label className={LBL_CLS}>Pesquisar</label>
          <input value={q} onChange={(e) => setQ(e.target.value)}
            placeholder="Título do conteúdo…" data-testid="ms-filter-q"
            className="w-full px-3 py-2 text-sm border border-[#E6E1D6] rounded" />
        </div>
        <button type="submit" data-testid="ms-btn-search"
          className="px-3 py-2 bg-[#0F1829] text-white rounded text-sm inline-flex items-center gap-1.5">
          <Search size={14} /> Filtrar
        </button>
      </form>
    </div>
  );
}
